import script from "./RcItemCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcItemCard.vue?vue&type=script&setup=true&lang=ts"

import "./RcItemCard.vue?vue&type=style&index=0&id=4d56048d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d56048d"]])

export default __exports__